import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { format } from 'date-fns'
import PackageGroup from './PackageGroup'
import EventType from './EventType'

@inject("store")
@observer
export default class PackageChooser extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    onChange: PropTypes.func
  }

  handleChooseNewDate = (e) => {
    const { store } = this.props
    e.preventDefault()
    store.activeDate = null
  }

  render() {
    const { store } = this.props

    return (
      <div className="package-selector">
        <div className="cc-header">
          <div className="you-chose">
            You chose
          </div>
          <div className="cc-title">
            { format(store.activeDate, store.franchise.attributes.dateFormat) }
          </div>

          <a
            href="#go-back"
            onClick={this.handleChooseNewDate}
            className="go-back"
          >
            Or click here to choose a new date
          </a>
        </div>
        <div className="cc-content">
          <div className="intro">
            Next, choose a package:
          </div>
          { store.groupedPackageGroups.map(({ eventCategory, packageGroup }) =>
            <PackageGroup 
              key={packageGroup.id}
              packageGroup={packageGroup}
              eventCategory={eventCategory}
            >
              { store.sortedEventTypesForPackageGroup(packageGroup).map(eventType =>
                <EventType
                  key={eventType.id}
                  eventType={eventType}
                />
              )}
            </PackageGroup>
          )}
        </div>
      </div>
    )
  }
}
